import http from '@/utils/http'

// 获取目录列表
export function getUrl(data) {
  return http({
    url: 'ahan/dir',
    method: 'post',
    data
  })
}

// 获取文件内容
export function getContent(data) {
  return http({
    url: 'ahan/getcontent',
    method: 'post',
    data
  })
}

// 获取历史版本藏文内容
export function getHistoryZWContent(data) {
  return http({
    url: 'ahan/getvercontent',
    method: 'post',
    data
  })
}

// 搜索文件内容
export function getSearch(data) {
  return http({
    url: 'ahan/search',
    method: 'post',
    data
  })
}

// 提交藏文编辑
export function submitContent(data) {
  return http({
    url: 'ahan/submit',
    method: 'post',
    data
  })
}

// 获取修订历史
export function getverlist(data) {
  return http({
    url: 'ahan/getverlist',
    method: 'post',
    data
  })
}
